import Swiper from "swiper";

export function gallerySlider() {
    var gallerySwiper = new Swiper(".gallery-slider", {
        slidesPerView: 2,
        loop: true,
        centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        freeMode: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        breakpoints: {
            320: {
                spaceBetween: 10,
                slidesPerView: 1.5,
            },
            768: {
                spaceBetween: 20,
                slidesPerView: 2
            },
            991: {
                spaceBetween: 30
            }
        }
    });
}
